import BaseAPI from "./baseAPI";

class QuestionAPI extends BaseAPI{
  get entity() {
    return {
      route: `/questions`,
      name: 'السؤال'
    }
  }
}

export default new QuestionAPI()
